import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { formatCustomDate } from "../services/dateService";

export const formatTextWithLineBreaks = (text) => {
  if (!text) return "";
  return text.split("\n").map((line, index) => (
    <React.Fragment key={index}>
      {line}
      <br />
    </React.Fragment>
  ));
};

export const trasformStringToArray = (string, separator) => {
  const resultArray = string.split(separator);
  const trimmedArray = resultArray.map((line) => line.trim());

  return trimmedArray;
};

export const usePageChangeEffect = (callback) => {
  const location = useLocation();

  useEffect(() => {
    callback();
  }, [location.pathname]);
};

export const generateSelectList = (dataList, valueKey, nameKey, isDate = false) => {
  if (!Array.isArray(dataList)) {
    throw new Error("El primer argumento debe ser un array.");
  }

  const seen = new Set();

  const filteredData = dataList.filter((item) => {
    const key = item[valueKey];
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });

  // Ordenar por el número que aparece en el string del nombre (nameKey)
  const sortedData = [...filteredData].sort((a, b) => {
    const numA = parseInt((a[nameKey] || "").match(/\d+/)?.[0] || 0, 10);
    const numB = parseInt((b[nameKey] || "").match(/\d+/)?.[0] || 0, 10);
    return numA - numB;
  });

  return sortedData.map((item) => {
    const value = item[valueKey];
    const name = item[nameKey];
    return {
      value,
      name: isDate ? formatCustomDate(name) : name
    };
  });



  return dataList
    .filter((item) => {
      const key = item[valueKey];
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .map((item) => {
      const value = item[valueKey];
      const name = item[nameKey];
      return {
        value,
        name: isDate ? formatCustomDate(name) : name
      };
    });
};

export const moneyTransform = (value) => {
  if (typeof value !== "number") return "$0";
  return `$${value.toLocaleString("es-CO")}`;
};

export const formatWithDots = (number) => {
  if (number == null || isNaN(number)) return "0";
  return number
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};